import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { MaterialAutocomplete } from 'console/shared/components/fields';
import { changeSimInDevice } from 'console/sim/redux/actions';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { getDeviceIdBySim, sim_for_device_selector } from 'console/sim/utils/select-sim';
export function SimInDeviceRow(props) {
    const { sim_in_device } = props;
    const devices = useAppSelector(sim_for_device_selector);
    const selected_device_id = getDeviceIdBySim(devices, sim_in_device);
    const onChangeSimInDevice = useAction(changeSimInDevice);
    const options = useMemo(() => [
        { name: 'Устройства', options: devices.map(({ id, name }) => ({ id, name })) },
    ], [devices]);
    const onChange = useCallback((new_id) => {
        if (new_id == null) {
            onChangeSimInDevice(selected_device_id, null);
        }
        else {
            onChangeSimInDevice(new_id, sim_in_device);
        }
    }, [onChangeSimInDevice, selected_device_id, sim_in_device]);
    return (_jsx(ErrorBoundary, { children: _jsx("form", { autoComplete: "off", children: _jsx(MaterialAutocomplete, { notChosenTitle: "\u041D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u043E", notChosenValue: "-1", value: selected_device_id, onChange: onChange, options: options, label: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0430 \u0432 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435", validation_result: null, validation_warnings_result: null, help_id: null, disableChoseOptionForSelected: true }) }) }));
}
